import { ApiCall } from '../../../../http-service/types/ApiCall';
import { SSOTokenData } from '../../../types/SSOTokenData';
import { zitadelHttpService } from '../zitadel-http-service';
import { ZitadelAuthTokenExchangeParams } from './types/ZitadelAuthTokenExchangeParams';
import { ZitadelRefreshTokenExchangeParams } from './types/ZitadelRefreshTokenExchangeParams';

type TokenExchangeParams = ZitadelAuthTokenExchangeParams | ZitadelRefreshTokenExchangeParams;

export const exchangeZitadelToken: ApiCall<TokenExchangeParams, SSOTokenData> = async ({
  params,
  abortSignal,
}) => {
  const { data } = await zitadelHttpService.post(
    '/oauth/v2/token',
    params,
    abortSignal
  );
  return data;
};